import { Directive, Renderer2, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const INTEGER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => IntegerValueAccessorDirective),
  multi: true
};

@Directive({
  selector: `
    input:not([type])[ngModel][appIntegerValueAccessor],
    input:not([type])[formControl][appIntegerValueAccessor],
    input:not([type])[formControlName][appIntegerValueAccessor],
    input:[type=number][ngModel][appIntegerValueAccessor],
    input:[type=number][formControl][appIntegerValueAccessor],
    input:[type=number][formControlName][appIntegerValueAccessor],
    input:[type=text][ngModel][appIntegerValueAccessor],
    input:[type=text][formControl][appIntegerValueAccessor],
    input:[type=text][formControlName][appIntegerValueAccessor],
    input[appIntegerValueAccessor]
  `,
  host: {
    '(blur)': 'onTouched()',
    '(input)': 'onValueChanged($event.target.value)'
  },
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: IntegerValueAccessorDirective,
    multi: true
  }],
  exportAs: 'appIntegerValueAccessor'
})
export class IntegerValueAccessorDirective implements ControlValueAccessor {
  onChange: (value: number) => void = (value: number) => { };
  onTouched: () => void = () => { };

  constructor(private renderer: Renderer2, private elementRef: ElementRef) {
  }

  writeValue(obj: any): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'value', obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  onValueChanged(text: string) {
    if (!text || !/^-?[0-9]+$/.test(text)) {
      this.onChange(null);
      return;
    }

    const value = Number(text);

    if (Math.floor(value) !== value) {
      this.onChange(null);
      return;
    } else {
      this.onChange(value);
    }
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/directives/integer-value-accessor.directive.ts